import React, { Component } from "react";
import {
  Route,
  HashRouter
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import Home from "./Home";
import DeckBuilder from "./DeckBuilder";
import DeckBuilderV2 from "./DBV2/DeckbuilderV2";
import Cards from "./Cards";
import Decks from "./Decks";
import ArticleCollection from "./ArticleCollection";
import Footer from "./Footer";
import Login from "./Authentication/Login";
import SignUpPage from './Authentication/SignUp';
import UserHome from './Authentication/UserHome';
import PasswordForgetPage from './Authentication/PasswordForget.js'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand
} from 'reactstrap';
import logo from './NovaBlitzHQLogov31.png';
import * as routes from './Constants/routes';
import ScrollToTop from './Constants/ScrollToTop';
import NavigationLinks from './Constants/Navigation';
import GrimmInterview from "./Articles/GrimmInterview";
import BossryutsuInterview from "./Articles/BossryutsuInterview";
import OpenForBusiness from "./Articles/OpenForBusiness";
import FridayBlitz from "./Articles/FridayBlitz";
import DeckBuildingLive from "./Articles/DeckBuildingLive";
import withAuthentication from './Authentication/withAuthentication';
import DeckView from "./DBV2/DeckView";
import TournamentGrid from "./Tournaments/TournamentGrid";
import Tournament from "./Tournaments/Tournament";
import DeckSelect from "./Tournaments/DeckSelect";
import ArchonBomb from "./Articles/ArchonBomb";
import Friday1 from "./Articles/Friday1";
import Friday2 from "./Articles/Friday2";
import Friday3 from "./Articles/Friday3";
import withTracker from "./Constants/WithTracker";
import Rankings from "./LeaderBoard/Rankings";
import ArticleBase from "./Articles/ArticleBase";
import Parchment from "./Admin/Parchment";



class Main extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
//    this.fireTracking = this.fireTracking.bind(this);
    this.state = {
      authUser: null,
      isOpen: false
    };
  }

  componentDidMount() {
  //  ReactGA.initialize('UA-114689256-1');
  }

  //fireTracking() {
    //  ReactGA.pageview(window.location.hash);
//  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }


  render() {
    var imageHeightStyle= {
      height: 40
    }

    var navbarStyle={
      backgroundColor: "black",
      borderBottomStyle: "solid",
      borderColor: "darkslategray"
    }

    var navbarToggleStyle={
      backgroundColor: "black"
    }
    return (
        <HashRouter onUpdate={this.fireTracking}>
          <ScrollToTop>
          <React.Fragment>
          <Navbar className="navbar-dark fixed-top" style={navbarStyle} expand="lg">
            <NavbarBrand href="/"><img id="logo" src={logo} className="img-fluid" style={imageHeightStyle} alt="" /></NavbarBrand>

            <NavbarToggler onClick={this.toggle} />
              <Collapse className="navbar-dark" style={navbarToggleStyle} isOpen={this.state.isOpen} navbar>

                <NavigationLinks  menuToggle={this.toggle}/>

              </Collapse>
            </Navbar>
          <div>

            </div>
            <div className="Site">

                      <Route exact path="/" component={withTracker(Home)}/>
                      <Route path="/Cards"  component={withTracker(Cards)}/>
                      <Route path="/Decks"  component={withTracker(Decks)}/>
                      <Route path="/DeckBuilder" component={withTracker(DeckBuilder)}/>
                      <Route path="/ArticleCollection" component={withTracker(ArticleCollection)}/>
                      <Route path={routes.LOGIN} component={withTracker(Login)}/>
                      <Route path={routes.SIGN_UP} component={withTracker(() => <SignUpPage />)}/>
                      <Route path={routes.HOME} component={withTracker(() => <UserHome />)} />
                      <Route path={routes.GRIMM}  component={withTracker(GrimmInterview)}/>
                      <Route path={routes.PASSWORD_FORGET} component={withTracker(() => <PasswordForgetPage />)}/>
                      <Route path={routes.OPEN} component={withTracker(OpenForBusiness)}/>
                      <Route path={routes.DECKBUILDERV2} component={withTracker(DeckBuilderV2)}/>
                      <Route path="/DBV2/DeckView/:deckId"  component={withTracker(DeckView)} />
                      <Route path={routes.DECKSLIVE} component={withTracker(DeckBuildingLive)} />
                      <Route path={routes.BOSSINTERVIEW}  component={withTracker(BossryutsuInterview)} />
                      <Route path={routes.TOURNAMENTGRID} component={withTracker(TournamentGrid)} />
                      <Route path="/Tournaments/Tournament/:tournamentId" component={withTracker(Tournament)} />
                      <Route path={routes.FRIDAYBLITZ} component={withTracker(FridayBlitz)} />
                      <Route path={routes.DECKSELECT}  component={withTracker(DeckSelect)} />
                      <Route path={routes.ARCHONBOMB} component={withTracker(ArchonBomb)} />
                      <Route path={routes.FRIDAY1}  component={withTracker(Friday1)} />
                      <Route path={routes.FRIDAY2}  component={withTracker(Friday2)} />
                      <Route path={routes.LEADERBOARD} component={withTracker(Rankings)} />
                      <Route path={routes.FRIDAY3}  component={withTracker(Friday3)} />
                      <Route path={routes.ARTICLEBASE + ":articleId"} component={withTracker(ArticleBase)} />
                      <Route path={routes.PARCHMENT} component={Parchment} />

              </div>
              <Footer />
          </React.Fragment>
          </ScrollToTop>
          </HashRouter>


    );
  }
}

export default withAuthentication(Main);




/*
was in the componentDidMount section
firebase.auth.onAuthStateChanged(authUser => {
  authUser
    ? this.setState(() => ({ authUser }))
    : this.setState(() => ({ authUser: null }));
});
*/



// WEBPACK FOOTER //
// ./src/Main.js